import React from 'react';
import './SupportFloatingButton.css';

interface SupportFloatingButtonProps {
    onClick: () => void;
    isOpen: boolean;
}

const SupportFloatingButton: React.FC<SupportFloatingButtonProps> = ({ onClick, isOpen }) => {
    return (
        <div className={`support-floating-container ${isOpen ? 'is-open' : ''}`} onClick={onClick}>
            <div className="support-label">Dudas o Reclamos</div>
            <div className="support-icon-circle">
                <i className={`bi ${isOpen ? 'bi-x-lg' : 'bi-headset'}`}></i>
            </div>
        </div>
    );
};

export default SupportFloatingButton;
